import React from "react";
import HomeElementGrid from "./HomeElementGrid";
import HomeItemDescription from "./HomeItemDescription";
import st from "../HomeNew.module.css"

class HomeElementGridContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      homeElement: this.props.homeElement
    }
  }

  handleDeletePlaylist = (id) => {
    this.state.homeElement.items.data = this.state.homeElement.items.data.filter(playlist => playlist.id !== id)
    this.setState({homeElement: this.state.homeElement})
  }

  render() {
    return (
      <section className={st["section"]}>
        {/* Divisor */}
        <div className={st["row-category"]} style={{ width: "100%", position: "relative", float: "left" }}>
          {!!this.state.homeElement.title &&
            <>
              {this.props.showSectionTitle &&
              <div className={st['category-title']}>
                <h5 className={`${st["title"]} ${st["bold"]} `}>
                  {this.state.homeElement.title}
                </h5>
              </div>
              }
            </>
          }

        <HomeElementGrid
          ref='elementDescription'
          sizes={this.props.sizes}
          requestElement={this.props.requestElement}
          showMore={this.props.showMore}
          rowsToShow={this.props.rowsToShow}
          maxPerRow={this.props.maxPerRow}
          shape={this.props.shape}
          fixedTitle={this.props.fixedTitle}
          withBackground={this.props.withBackground}
          homeElement={this.state.homeElement}
          renderGridElement={(element, onClick) => <this.props.itemComponent {...this.props} data={element} onClick={onClick} onDelete={(id) => this.handleDeletePlaylist(id) }/>}
          renderElementDescription={(element, onClose) => <HomeItemDescription
            {...this.props}
            data={element}
            onClose={() => {
              this.refs.elementDescription.resetRequestedElement();
              onClose()
            }}
            trackType={this.props.trackType()}
            dataType={this.props.dataType}
            home={this.props.home}
          />}
        />
        </div>
      </section>
    )
  }

}

HomeElementGridContainer.defaultProps = {
  showSectionTitle: true
}

export default HomeElementGridContainer
